import React from "react";
import { mergeProps, useFocusable } from "react-aria";
import {
  Tooltip as RACTooltip,
  type TooltipProps as RACTooltipProps,
} from "react-aria-components";

import { composeTailwindRenderProps } from "./utils";

export { TooltipTrigger } from "react-aria-components";

type TooltipProps = RACTooltipProps & {
  ref?: React.Ref<HTMLDivElement>;
};

export function Tooltip({ ref, offset = 6, ...props }: TooltipProps) {
  return (
    <RACTooltip
      {...props}
      ref={ref}
      offset={offset}
      className={composeTailwindRenderProps(
        props.className,
        "relative z-50 max-w-[280px] rounded-lg border border-border bg-popover px-3 py-1.5 text-sm text-popover-foreground animate-in fade-in-0 zoom-in-95 ease-cool data-exiting:animate-out data-exiting:fade-out-0 data-exiting:zoom-out-95 data-[placement=bottom]:slide-in-from-top-2 data-[placement=left]:slide-in-from-right-2 data-[placement=right]:slide-in-from-left-2 data-[placement=top]:slide-in-from-bottom-2",
      )}
    />
  );
}

// https://argos-ci.com/blog/react-aria-migration
export function NonFocusableTooltipTarget(props: {
  children: React.ReactElement;
}) {
  const triggerRef = React.useRef(null);
  const { focusableProps } = useFocusable(
    // biome-ignore lint/suspicious/noExplicitAny: it's ok
    props.children.props as any,
    triggerRef,
  );

  return React.cloneElement(
    props.children,
    // biome-ignore lint/suspicious/noExplicitAny: it's ok
    mergeProps(focusableProps, { tabIndex: 0 }, props.children.props as any, {
      ref: triggerRef,
    }),
  );
}
